
import { AvaliacaoGenericaAccordion } from "components/avaliacao/AvaliacaoGenericaAccordion";
import { AvaliacaoRequisitosAccordion } from "components/avaliacao/AvaliacaoRequisitosAccordion";
import { FC } from "react";
import { IInscricaoEtapa } from "shared/features/api/inscricao/types";

interface Props {
  etapa: IInscricaoEtapa;
  idInscricao: number;
}

export const EtapaAcordeaoItem: FC<Props> = ({ etapa, idInscricao }) => {
  switch (etapa.nomeEtapa) {
    case "Requisitos":
      return (
        <AvaliacaoRequisitosAccordion etapa={etapa} idInscricao={idInscricao} />
      );

    default:
      return (
        <AvaliacaoGenericaAccordion etapa={etapa} idInscricao={idInscricao} />
      );
  }
};
